import { createFileRoute, Outlet, stripSearchParams } from "@tanstack/react-router";
import { zodValidator, fallback } from "@tanstack/zod-adapter";
import { z } from "zod";

const stateSearchSchema = z.object({
  ig: fallback(z.string(), "all").default("all"),
});

export const Route = createFileRoute("/states/$stateSlug")({
  component: () => <Outlet />,
  validateSearch: zodValidator(stateSearchSchema),
  search: {
    middlewares: [stripSearchParams({ ig: "all" })],
  },
});